module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-0b2cff9cc53ad3c3f7164312e4be0cc0.png";